import React from 'react';
import { Button } from 'antd';
import s from './s.module.less';
import { useNavigate } from 'react-router-dom';
import { PATH } from 'constants/path';
import usePPAChanneld from 'hooks/usePPAChanneld';

const SetupNoShow: React.FC<{ className: string; }> = ({
    className,
}) => {
    const navigate = useNavigate();
    const [ppaId, loadingPPA] = usePPAChanneld();
    return (
        <div className={`${s.wrapper} ${className}`}>
            <div className={s.content}>
                <div className={s.title}>
                    Set up your no-show policy and get paid
                </div>
                <div className={s.desc}>
                    Protect your time and get paid faster. Set up your no-show and cancellation policy, confirm your payment details, and start collecting payments from patients.
                </div>
                <div className={s.buttonWrap}>
                    <Button
                        type="primary"
                        onClick={() => {
                            navigate(
                                `/${PATH.PAYMENT_SETUP}`,
                            );
                        }}
                    >
                        Set up no-show policy
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default SetupNoShow;
